import { useMutation, UseMutationConfig } from '@libs/use';
import { OrderItem } from '@libs/api-reference';

import * as API from '../requests';

function deleteOrderFactory({
  order,
  deviceType,
  orderExecutionType,
}: {
  order: OrderItem;
  deviceType: number;
  orderExecutionType: string;
}) {
  const { orderId, instrumentIdentification } = order;

  return {
    orderId,
    personageId: 1,
    orderExecutionType,
    deviceType,
    instrumentIdentification: instrumentIdentification as string,
  };
}

type UseDeleteOrderQueryConfigs = {
  deviceType: number;
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
  orderExecutionType: string;
};

export default function useDeleteOrderQuery({
  deviceType,
  onReject,
  onSuccess,
  orderExecutionType,
}: UseDeleteOrderQueryConfigs) {
  const {
    execute: deleteOrder,
    isPending: isLoadingDeleteOrder,
    isError: isErrorDeleteOrder,
    ...query
  } = useMutation(
    ({ selectedOrder: order }: { selectedOrder: OrderItem }) =>
      API.deleteOrder(
        deleteOrderFactory({ order, deviceType, orderExecutionType })
      ),
    {
      onReject,
      onSuccess,
    }
  );

  return { deleteOrder, isLoadingDeleteOrder, isErrorDeleteOrder, ...query };
}
